import * as React from 'react';
import PropTypes from 'prop-types';

const ArrowCollapseUp = (props) => (
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.70711 0.8237C8.31659 0.43312 7.68338 0.433093 7.29283 0.823641L0.706606 7.40987C0.316277 7.8002 0.316054 8.43298 0.706107 8.82358L1.17353 9.29166C1.56406 9.68275 2.19779 9.68287 2.58847 9.29193L8 3.87687L13.4107 9.29228C13.8012 9.68309 14.4346 9.68323 14.8252 9.29259L15.293 8.82485C15.6835 8.43435 15.6835 7.80123 15.293 7.4107L8.70711 0.8237Z"
      fill={props.color || '#83858F'}
    />
  </svg>
);

ArrowCollapseUp.propTypes = {
  color: PropTypes.string,
};

export default ArrowCollapseUp;
